import { Component, OnInit, ViewChild, ElementRef, ChangeDetectorRef, HostListener } from '@angular/core';
import { PendingRequest, Sub, Specification, Remark } from 'src/app/service/modal/pendingrequest';
import { PendingRequestService } from 'src/app/service/apiservice/pendingrequest.service';
import { Globals } from '../../../globals';
declare var $;
import {Directive, HostBinding, Input} from '@angular/core';
import {DomSanitizer, SafeHtml} from '@angular/platform-browser';
import { DatePipe } from '@angular/common';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { MailViewService } from '../../../service/apiservice/mailview.service';
import { Approved } from '../../../service/modal/approved';
import { NgxSpinnerService } from 'ngx-spinner';
declare function info_noti(msg:any):any;

@Component({
  selector: 'app-pendingrequest',
  templateUrl: './pendingrequest.component.html',
  styleUrls: ['./pendingrequest.component.css']
})
export class PendingrequestComponent implements OnInit {
 
  pendingRequestGrid: PendingRequest[] = new Array();
  acceptPendingRequest: PendingRequest = new PendingRequest();
  pendingRequestViewData: PendingRequest = new PendingRequest();
  pendingRequestAttachmentData: any;
  @ViewChild('acceptForm') acceptForm: any;
  @ViewChild('AcceptCloseForm') accept_CloseForm: ElementRef;
  @ViewChild('AttachmentCloseForm') attachment_CloseForm: ElementRef;
  eyeIcon: string = "zmdi-eye-off";
  starIcon: string = "zmdi-star-outline";
  showActions: any;
  selectedMailList = [];
  todayDate: any;
  //subject DropDown//
  subjectDropDown: any;
  subjectDropDown_SelectedId: number[] = [];
  //subject DropDown//

  //Specification DropDown//
  specificationDropDown: any;
  specificationDropDown_SelectedId: number[] = [];
  //Specification DropDown//

  //Remark DropDown//
  remarkDropDown: any;
  remarkDropDown_SelectedId: number[] = [];
  //Remark DropDown//
  //decilne pre binding
  declineDataId:any;
  pipe = new DatePipe('en-US');

  approvedAttachmentData: any;
  approvedAttachmentDataShow: any;
  hoveredIndex;
  checkClickCount = 0;
 appvar;
 pendingDeclineObj;
 pendingRequestMultiple= new Array();

  constructor( private spinner: NgxSpinnerService,private _mailService:MailViewService, private datePipe: DatePipe,private router:Router, private _pendingRequestService: PendingRequestService, private chref: ChangeDetectorRef,private global:Globals) { 
 
  }
 
  todate
  ngOnInit() {
    localStorage.setItem("Active Route",this.router.url);
    this.global.afterRefreshPageSetToken();
    this.GetPendingRequest_Grid();
    this.acceptPendingRequest.hide = false;
    this.acceptPendingRequest.star = false;
    this.todayDate = new Date();
    console.log(this.todayDate);
    $(".modal-wide").on("show.bs.modal", function() {
      var height = $(window).height() - 80;
      $(this).find(".modal-body").css("max-height", height);
    });

    this.secificationCobo();
    this.subjectCombo();
  }

  checkYear(data): Boolean {
    let userDate = new Date(data);
    if (userDate.getFullYear() == this.todayDate.getFullYear()) {
      return true;
    }
    else {
      return false;
    }
  }




  //Accept
  Accept_CloseClick() {
    this.acceptForm.resetForm();
  }

  Accept_PendingRequestDataBind(data: PendingRequest) {
 
    Object.assign(this.acceptPendingRequest, data);


    //Subject Dropdown
    this._pendingRequestService.GetAllSubject()
      .subscribe((response) => {
        debugger;
        this.subjectDropDown=[];
        this.subjectDropDown = response;
        this.subjectDropDown_SelectedId=[];
        for (let d of this.subjectDropDown) {
          if(this.acceptPendingRequest.subject.toLowerCase()==d.name.toLowerCase()){
            this.subjectDropDown_SelectedId.push(d.subjectId);
          }
        }
        
        if(this.subjectDropDown_SelectedId.length==0)
        {
          this.subjectDropDown.push({subjectId: 0, name: this.acceptPendingRequest.subject, descrition: this.acceptPendingRequest.subject})
          this.subjectDropDown_SelectedId.push(0);
        }
      },
        error => {
          console.log(error);
        })

    //Specification Dropdown
    // this._pendingRequestService.GetAllSpecification()
    //   .subscribe((response) => {
    //     this.specificationDropDown = response;
    //   },
    //     error => {
    //       console.log(error);
    //     })

    //Remark Dropdown
    this._pendingRequestService.GetAllRemark()
      .subscribe((response) => {
        this.remarkDropDown = response;
      },
        error => {
          console.log(error);
        })
  }

  Eye_Click() {
    this.eyeIcon = this.eyeIcon == "zmdi-eye" ? "zmdi-eye-off" : "zmdi-eye";
    this.acceptPendingRequest.hide = this.eyeIcon == "zmdi-eye" ? true : false;
    // if( this.acceptPendingRequest.hide){
    //    info_noti("Hide Click.....");
    // }else{
    //    info_noti("UnHide Click.....");
    // }


  }

  Star_Click() {
    this.starIcon = this.starIcon == "zmdi-star" ? "zmdi-star-outline" : "zmdi-star";
   
    this.acceptPendingRequest.star = this.starIcon == "zmdi-star" ? true : false;
    // if( this.acceptPendingRequest.star){
    //    info_noti("Stared Click.....");
    // }else{
    //    info_noti("UnStared Click.....");
    // }
  }

  Accept_PendingRequestSubmit() {

    //sub data
    var localsub: Sub[] = new Array();
    if (this.subjectDropDown_SelectedId != undefined) {
    for (let data of this.subjectDropDown_SelectedId) {
      if (isNaN(data)) {
        var newSub: Sub = {
          subjectId: 0,
          name: data.toString(),
        }
        localsub.push(newSub);
      }
      else {
        var oldSub: Sub = {
          subjectId: data,
          name: this.subjectDropDown.find(a => a.subjectId == data).name,
        }
        localsub.push(oldSub);
      }
    }
    }
    //spec data
    var localspec: Specification[] = new Array();
    if (this.specificationDropDown_SelectedId != undefined) {
    for (let data of this.specificationDropDown_SelectedId) {
      if (isNaN(data)) {
        var newSpec: Specification = {
          specificationId: 0,
          name: data.toString(),
        }
        localspec.push(newSpec);
      }
      else {
        var oldSpec: Specification = {
          specificationId: data,
          name: this.specificationDropDown.find(a => a.specificationId == data).name,
        }
        localspec.push(oldSpec);
      }
    }
   }
    //remark data
    var localrmk: Remark[] = new Array();
    if (this.remarkDropDown_SelectedId != undefined) {
    for (let data of this.remarkDropDown_SelectedId) {
      if (isNaN(data)) {
        var newRmk: Remark = {
          remarkId: 0,
          name: data.toString(),
        }
        localrmk.push(newRmk);
      }
      else {
        var oldRmk: Remark = {
          remarkId: data,
          name: this.remarkDropDown.find(a => a.remarkId == data).name,
        }
        localrmk.push(oldRmk);
      }
    }
   }
    this.acceptPendingRequest.sub = localsub;
    this.acceptPendingRequest.spec = localspec;
    this.acceptPendingRequest.remark = localrmk;

    this._pendingRequestService.AcceptPendingRequest(this.acceptPendingRequest)
      .subscribe((response) => {
        info_noti('Approved Request Success...');
        this.acceptPendingRequest.hide = false;
        this.acceptPendingRequest.star = false;
        this.acceptForm.resetForm();
        this.accept_CloseForm.nativeElement.click();
        $("#ViewModal").modal("hide");
        $("body").removeClass('modal-open');
        $('.modal-backdrop').remove();
        this.GetPendingRequest_Grid();
        this.eyeIcon= "zmdi-eye-off";
        this.starIcon= "zmdi-star-outline";
        window.location.reload();
      },
        error => {
          info_noti('Request Not Approved...');
          console.log(error);
        });
  
  }
  //Accept

  //Decline

Decline_DataPreBinding(id){
  this.declineDataId=id;

}

  Decline_Submit(id) {
    debugger;
    this._pendingRequestService.DeclineRequest(id)
      .subscribe((response) => {
        console.log(response);
        this.GetPendingRequest_Grid();
  })
      //decline model hide
      $("#DeclineConfirmModal").modal("hide");
      $("body").removeClass('modal-open');
      $('.modal-backdrop').remove();
   //view model hide;
      $("#ViewModal").modal("hide");
      $("body").removeClass('modal-open');
      $('.modal-backdrop').remove();
  }
  //Decline

  GetPendingRequest_Grid() {
    // this.spinner.show();
    this._pendingRequestService.GetPendingRequest()
      .subscribe((response) => {
        Object.assign(this.pendingRequestGrid, response);
        // this.spinner.hide();

        //pending request has no data show approved data
     if(this.global.refreshCount==0){
      if(this.pendingRequestGrid.length==0){
        this.global.refreshCount=1;
        this.router.navigate(['/dashboard/subject']);
       }
     }

        if ($.fn.dataTable.isDataTable('#pendingdatatable')) {
          $('#pendingdatatable').dataTable().fnClearTable();
          $('#pendingdatatable').dataTable().fnDestroy();
        }
        if ($.fn.dataTable.isDataTable('#pendingdatatable_IsMobile')) {
          $('#pendingdatatable_IsMobile').dataTable().fnClearTable();
          $('#pendingdatatable_IsMobile').dataTable().fnDestroy();
        }

        // Object.assign(this.pendingRequestGrid, response);
       

        this.chref.detectChanges();
        $('#pendingdatatable').DataTable({
          "paging": false,
          "info": false,
          "order":[[5,'desc']],
          'columnDefs': [{ 'orderable': false, 'targets': 0 }],
        });
        $('#pendingdatatable_filter').hide();

        $('#pendingdatatable_IsMobile').DataTable({
          "paging": false,
          "info": false,
          "order":[[3,'desc']],
          'columnDefs': [{ 'orderable': false, 'targets': 0 }],
          
        });
        $('#pendingdatatable_IsMobile_filter').hide();

      }, error => {
        console.log(error);
      })
  }

  ViewDataBind(data: PendingRequest) {

    Object.assign(this.pendingRequestViewData, data);
  }

  //Attachment
  attachmentClick(attachment) {
     info_noti(attachment.fileType)
  }

  Attachment_CloseClick() {
    this.attachment_CloseForm.nativeElement.click();
  }
  addCancelClick() {
    this.accept_CloseForm.nativeElement.click();
  }
  Attachment_DataBind(data: any) {
    this.pendingRequestAttachmentData = data;
  }
  //Attachment

  // checkboxChanged(event) {
  //   if (event.target.checked) {
  //     this.selectedMailList.push(event.target.value);
  //   }
  //   else {
  //     this.selectedMailList.splice(this.selectedMailList.indexOf(event.target.value), 1);
  //   }
  //   this.selectedMailList = Array.from(new Set(this.selectedMailList));

  //   if (this.selectedMailList.length > 0) { this.showActions = true; }
  //   else { this.showActions = false; }
  // }


  checkboxChanged(event, obj, status, allSelectedList,type) {
    debugger;
if(type=="mobile"){

  if (status == "selectAll") {
    if (event.target.checked) {
      var i = 1;
      allSelectedList.forEach(element => {
        this.selectedMailList.push(element.emailData_Id);
        $('#checkboxm' + i).prop("checked", true);
        i++;
      })
    } else {

      var i = 1;

      allSelectedList.forEach(element => {
        this.selectedMailList.splice(this.selectedMailList.indexOf(element.emailData_Id, 1));

        $('#checkboxm' + i).prop("checked", false);
        i++;
      })
    }

  } else {

    if (event.target.checked) {
      this.selectedMailList.push(obj.emailData_Id);
      if (this.selectedMailList.length == this.pendingRequestGrid.length) {
        $('#selectAllm').prop("checked", true);
      }

    }
    else {
      $('#selectAllm').prop("checked", false);
      this.selectedMailList.splice(this.selectedMailList.indexOf(obj.emailData_Id), 1);
    }
  }
  this.selectedMailList = Array.from(new Set(this.selectedMailList));

  if (this.selectedMailList.length > 0) {
    this.showActions = true;
    if (this.checkClickCount == 0) {
      this.checkClickCount = 1;
      // this.approvedObjActionShow = obj;
    }
  }
  else {
    this.checkClickCount = 0;
    // this.approvedObjActionShow = null;
    this.showActions = false;
  }
}else{
    if (status == "selectAll") {
      if (event.target.checked) {
        var i = 1;
        allSelectedList.forEach(element => {
          this.selectedMailList.push(element.emailData_Id);
          $('#checkbox' + i).prop("checked", true);
          i++;
        })
      } else {

        var i = 1;

        allSelectedList.forEach(element => {
          this.selectedMailList.splice(this.selectedMailList.indexOf(element.emailData_Id, 1));

          $('#checkbox' + i).prop("checked", false);
          i++;
        })
      }

    } else {

      if (event.target.checked) {
        this.selectedMailList.push(obj.emailData_Id);
        if (this.selectedMailList.length == this.pendingRequestGrid.length) {
          $('#selectAll').prop("checked", true);
        }

      }
      else {
        $('#selectAll').prop("checked", false);
        this.selectedMailList.splice(this.selectedMailList.indexOf(obj.emailData_Id), 1);
      }
    }
    this.selectedMailList = Array.from(new Set(this.selectedMailList));

    if (this.selectedMailList.length > 0) {
      this.showActions = true;
      if (this.checkClickCount == 0) {
        this.checkClickCount = 1;
        // this.approvedObjActionShow = obj;
      }
    }
    else {
      this.checkClickCount = 0;
      // this.approvedObjActionShow = null;
      this.showActions = false;
    }
  }
  }


  //DropDown Functions//
  subjectDropDown_Added = (term) => ({ subjectId: term, name: term });
  specificationDropDown_Added = (term) => ({ specificationId: term, name: term });
  remarkDropDown_Added = (term) => ({ remarkId: term, name: term });
  //DropDown Functions//

//amount Enterd only number
// onlyDigitEnter(event){
//   console.log("amount digit only")
//   $(document).ready(function () {
//     //called when key is pressed in textbox
//     $("#amount1").keypress(function (event) {
//       //if the letter is not digit then display error and don't type anything
//       if (event.which != 8 && event.which != 0 && (event.which < 48 || event.which > 57)) {
//         //display error message
//         $("#errmsg").html("Digits Only").show().fadeOut("slow");
//         return false;
//       }
//     });
//   });
// }
 AttachmentShow_DataBind(data){
   console.log(data);
   this.approvedAttachmentDataShow=data;
  }
  secificationCobo(){
    this._pendingRequestService.GetAllSpecification()
    .subscribe((response) => {
      this.specificationDropDown = response;
    },
      error => {
        console.log(error);
      })
  }


  subjectCombo(){
    this._pendingRequestService.GetAllSubject()
    .subscribe((response) => {
      debugger;
      this.subjectDropDown = response;
    },
      error => {
        console.log(error);
      })
  
  }
  approvedMultiple() {
    debugger;
    // this.subjectCombo();
    for (var i = 0; i < this.selectedMailList.length; i++) {
      this.pendingRequestGrid.forEach(element=>{
        if(this.selectedMailList[i]==element.emailData_Id){
          this.appvar = new Approved();
          // this.appvar=element;
          // this.appvar.email_Id=element.emailData_Id;
          this.pendingRequestMultiple.push(this.appobj(element)
      );
        }
      })
    }
    this._pendingRequestService.multipleApproved( this.pendingRequestMultiple).subscribe((response) => {
      info_noti('Approved Request Success...');
      this.selectedMailList.length = 0;
      this.appvar
      this.pendingRequestMultiple=[];
      if (this.selectedMailList.length > 0) {
        this.showActions = true;
      }
      else {
        // this.approvedObjActionShow = null;
        this.showActions = false;
        this.checkClickCount = 0;
      }
      $('#selectAll').prop("checked", false);
      $('#selectAllm').prop("checked", false);
      this.GetPendingRequest_Grid();
    }, error => { info_noti(error); }
    );
    console.log(this.selectedMailList);

  }

  declineMultiple(flag: boolean) {
    debugger;
    for (var i = 0; i < this.selectedMailList.length; i++) {
      this.pendingRequestGrid.forEach(element=>{
        if(this.selectedMailList[i]==element.emailData_Id){
          this.pendingDeclineObj = new PendingRequest();
          this.pendingDeclineObj=element;
          this.pendingDeclineObj.email_Id=element.emailData_Id;
          this.pendingRequestMultiple.push(this.pendingDeclineObj);
        }
      })
    }
    this._pendingRequestService.multipleDecline( this.pendingRequestMultiple).subscribe((response) => {
      info_noti('Decline Request Success...');
      this.selectedMailList.length = 0;
      this.pendingRequestMultiple=[];
      if (this.selectedMailList.length > 0) {
        this.showActions = true;
      }
      else {
        // this.approvedObjActionShow = null;
        this.showActions = false;
        this.checkClickCount = 0;
      }
      $('#selectAll').prop("checked", false);
      $('#selectAllm').prop("checked", false);
      this.GetPendingRequest_Grid();
    }, error => { info_noti(error); }
    );
    console.log(this.selectedMailList);

  }


appobj(element):any{

  Object.assign(this.acceptPendingRequest, element);
  this.subjectDropDown_SelectedId=[];
  for (let d of this.subjectDropDown) {
    if(this.acceptPendingRequest.subject.toLowerCase()==d.name.toLowerCase()){
      this.subjectDropDown_SelectedId.push(d.subjectId);
    }
  }
  
  if(this.subjectDropDown_SelectedId.length==0)
  {
    this.subjectDropDown.push({subjectId: 0, name: this.acceptPendingRequest.subject, descrition: this.acceptPendingRequest.subject})
    this.subjectDropDown_SelectedId.push(0);
  }

  var localsub: Sub[] = new Array();
  if (this.subjectDropDown_SelectedId != undefined) {
  for (let data of this.subjectDropDown_SelectedId) {
    if (isNaN(data)) {
      var newSub: Sub = {
        subjectId: 0,
        name: data.toString(),
      }
      localsub.push(newSub);
    }
    else {
      var oldSub: Sub = {
        subjectId: data,
        name: this.subjectDropDown.find(a => a.subjectId == data).name,
      }
      localsub.push(oldSub);
    }
  }
}

var objapp={
  "senderID": element.senderId,
  "ccId": element.ccId,
  "toId": element.toId,
  "body": element.body,
  "date_time": element.dateTime,
  "amount": element.amount,
  "hide": element.hide,
  "star": element.star,
  "deleted": false,
  "extra1": "",
  "extra2": "",
  "email_Id": element.emailData_Id,
  "user_id": element.user_id,
  "attachment": element.attachment,
  "sub": localsub,
  "spec": element.spec,
  "remark": element.remark
}
this.subjectDropDown_SelectedId=[];
this.acceptPendingRequest=new PendingRequest;
return objapp;
    
}

downloadFile(path){
  window.open(path, '_self');
}
//browser back button or mobile back button
@HostListener('window:popstate', ['$event'])
onPopState(event) {
  
  $("#ViewModal").modal("hide");
  $("body").removeClass('modal-open');
  $('.modal-backdrop').remove();

  $("#AcceptModal").modal("hide");
  $("body").removeClass('modal-open');
  $('.modal-backdrop').remove();

  $("#AttachmentModal").modal("hide");
  $("body").removeClass('modal-open');
  $('.modal-backdrop').remove();

  $("#attchmentShowModal").modal("hide");
  $("body").removeClass('modal-open');
  $('.modal-backdrop').remove();

  $("#DeclineConfirmModal").modal("hide");
  $("body").removeClass('modal-open');
  $('.modal-backdrop').remove();

}


}
